import cm from 'classnames';
import styles from './_title-credits.module.scss';
import { InputHeader } from 'components/UI/input/elements/input-header';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  className?: string;
  halfSize?: boolean;
}

export const __Section = ({ title, className, halfSize, children }: Props) => {
  return (
    <div className={cm(styles.Section, { [styles['Section--half']]: halfSize }, className)}>
      <InputHeader>{title}</InputHeader>
      {children}
    </div>
  );
};
